import { render, staticRenderFns } from "./NeedsCustomerProfile.vue?vue&type=template&id=42115d65&scoped=true&"
import script from "./NeedsCustomerProfile.vue?vue&type=script&lang=js&"
export * from "./NeedsCustomerProfile.vue?vue&type=script&lang=js&"
import style0 from "./NeedsCustomerProfile.vue?vue&type=style&index=0&id=42115d65&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42115d65",
  null
  
)

export default component.exports